export const Google = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
      data-prefix="fas"
      width={50}
      data-icon="linked-In"
      className="svg-inline--fa fa-google fa-w-20"
     
    >
      <path d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M12,21c-3.314,0-6-2.686-6-6 c0-3.314,2.686-6,6-6c1.56,0,2.981,0.596,4.047,1.573l-1.434,1.404C13.912,11.369,13,11,12,11c-2.209,0-4,1.791-4,4 c0,2.209,1.791,4,4,4c1.981,0,3.622-1.442,3.94-3.333H12v-2h5.843l0.033,0.133C17.956,14.188,18,14.589,18,15 C18,18.314,15.314,21,12,21z M23,16v2h-2v-2h-2v-2h2v-2h2v2h2v2H23z" />
    </svg>
  );
};
export const Linkedin = (props) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fas"
      data-icon="linked-In"
      className="svg-inline--fa fa-linkedin fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      width={45}
      viewBox="0 0 50 50"
    >
      {" "}
      <path d="M25,2C12.318,2,2,12.317,2,25s10.318,23,23,23s23-10.317,23-23S37.682,2,25,2z M18,35h-4V20h4V35z M16,17 c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C18,16.105,17.105,17,16,17z M37,35h-4v-5v-2.5c0-1.925-1.575-3.5-3.5-3.5 S26,25.575,26,27.5V35h-4V20h4v1.816C27.168,20.694,28.752,20,30.5,20c3.59,0,6.5,2.91,6.5,6.5V35z" />
    </svg>
  );
};
export const Facebook = (props) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="facebook"
      class="svg-inline--fa fa-facebook fa-w-16"
      role="img"
      width={40}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
      ></path>
    </svg>
  );
};
